

define([], function () {

    var _doc = document;
    var _w = window;
    var _tm = new Date().getTime();
    var _sH = screen.height;
    var _ht = escape(_w.location.href); // eslint-disable-line block-scoped-var,no-undef
    var _hr = escape(_doc.referrer); // eslint-disable-line block-scoped-var,no-undef
    var _sW = screen.width;

    function popUp(opinionlabURL) {
        _w.open(opinionlabURL, 'comments', 'width=535,height=192' + ',screenX=' + (_sW - 535) / 2 + ',screenY=' + (_sH - 192) / 2 + ',top=' + (_sH - 192) / 2 + ',left=' + (_sW - 535) / 2 + ',resizable=yes' + ',copyhistory=yes' + ',scrollbars=no');
    }

    function updateCustomVars(data) {

        var opVars = data.opVars;
        var locale = data.locale;

        _ht = 'https://' + locale.country + '.paypal.com/' + locale.languageCode + '/00/' + escape(opVars.page.replace(/\s|\//g, '_')) + '.page'; // eslint-disable-line block-scoped-var,no-undef

        var customVar = (opVars.rlogId || opVars.calc) + '|' + opVars.csci + '|' + opVars.page + '|' + locale.country + '|' + locale.languageCode + '|' + opVars.custId + '|' + opVars.merchantId + '|' + opVars.token + '|' + 'Unknown';
        return customVar;
    }

    function _fC(_u) {
        var _sp = '%3A\\/\\/';
        var _rp = '%3A//';
        var _aT = _sp + ',\\/,\\.,-,_,' + _rp + ',%2F,%2E,%2D,%5F';
        var _aA = _aT.split(',');

        for (var i = 0; i < 5; i++) {
            eval('_u=_u.replace(/' + _aA[i] + '/g,_aA[i+5])'); // eslint-disable-line no-eval
        }
        return _u;
    }

    return function (locale) {

        var custom_var = updateCustomVars(locale);

        var opinionlabURL = 'https://secure.opinionlab.com/ccc01/comment_card.asp?' + 'time1=' + _tm + '&time2=' + new Date().getTime() + '&prev=' + _fC(_hr) + '&referer=' + _fC(_ht) + '&height=' + _sH + '&width=' + _sW + '&custom_var=' + custom_var;
        popUp(opinionlabURL);
    };
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-page-components/src/footer/opinionlab.js
 ** module id = 503
 ** module chunks = 1
 **/